// images
import blogImg1 from "../images/blog/blog1.jpg";
import blogImg2 from "../images/blog/blog2.jpg";
import blogImg4 from "../images/update/blog4.jpg";
import blogImg5 from "../images/update/blog5.jpg";
import blogImg6 from "../images/update/blog6.jpg";

// images
import author1 from "../images/users/user1.jpg";
import author2 from "../images/users/user2.jpg";
import author3 from "../images/users/user3.jpg";


const blogs = [
    {
        id: '1',
        unit: 'culture',
        title: '"Maraş Gülü" COĞRAFİ İŞARET MARAŞ GÜLÜ MOTİFİ',
        titleEn: '“MARAŞ ROSE” GEOGRAPHICAL INDICATION: THE MARAŞ ROSE MOTIF',
        slug:'Start-a-fundraiser-for-yourself-in-World-Charity-Day',
        screens: blogImg1,
        authorImg: author1,
        description: 'Maraş Gülü, Kahramanmaraş ve ilçelerinde yaygın olarak yapılan, kültürü yansıtan yöresel bir kanaviçe motifidir. Bu motif, yapılan incelemeler neticesinde Kahramanmaraş ilinin kurtuluş günü ve milli mücadele anısına ithafen ilk kez Kahramanmaraş’ta yapılıp gelişmesi ve bu bölgeden yayılması nedeniyle motife bu ismin verildiği anlaşılmaktadır. Maraş gülü bir kanaviçe motifi olup, doğaya yakın bir üslup izlenerek biçimlendirilmiş ve renklendirmede de aynı gaye üzerinde durulmuştur. Motif, tek renkli (monogrom) bir düzen üzerine doğaya uygun renkli ipliklerin art arda çaprazlar “X” oluşturulması ile elde edilmektedir. Maraş gülü motifi geçmişte ve günümüzde ağırlıkla yatak örtüsü, yüklük örtüsü, çarşaf, karyola eteği, yorgan kapağı ve yastık kılıfı olmak üzere yatak takımlarına işlenmiş ve işlenmeye devam etmektedir.',
        descriptionEn: 'The Maraş Rose is a traditional cross-stitch motif widely used in Kahramanmaraş and its districts and reflects the region’s cultural heritage. Research indicates that the motif was first created and developed in Kahramanmaraş and later spread from the region. It follows a naturalistic style and is formed by successive X-shaped stitches with coloured threads. In the past and today, it has mainly been applied to bedding textiles such as bedspreads, sheets, valances, quilt covers and pillowcases.',
        author: 'Meltem ÖZSAN',
        authorTitle:'Öğretim Görevlisi',
        create_at: 'KAHRAMANMARAŞ - 2021',
        createAtEn: 'KAHRAMANMARAŞ — 2021',
        comment:'356',
        thumb:'Charity',
        blClass:'format-standard-image',
        col:'col-md-12 col-12',
        styleClass:'blogBlock--style1',
    },
    {
        id: '2',
        unit: 'art',
        title: 'Bilim , Kültür ve Sanat dergisi Kırkambar Kahramanmaraş"ta yayın hayatına başladı!',
        titleEn: 'KIRKAMBAR, A JOURNAL OF SCIENCE, CULTURE AND ART, BEGINS PUBLICATION IN KAHRAMANMARAŞ',
        slug:'do-you-know-why-african-people-year-of-year-waterless',
        screens: blogImg2,
        authorImg: author2,
        description: 'Kahmranmaraşta yayın hayatına yeni giren Kırkambar dergisinin Şehrimiz için aydınlatıcı ve gerekli değeri görmesini umuyor ve hayırlı olsun diyoruz.',
        descriptionEn: 'We wish Kırkambar, a newly launched journal in Kahramanmaraş, a successful publication life and hope it receives the attention and recognition it deserves for its contribution to our city.',
        author: 'KAED',
        authorTitle:'Creative Director',
        create_at: '17 Temmuz 2025',
        createAtEn: 'July 17, 2025',
        comment:'450',
        thumb:'Health',
        blClass:'format-standard-image',
        col:'col-md-6 col-12',
        styleClass:'blogBlock--style2',
    },
    {
        id: '4',
        title: 'Start a fundraiser for yourself in World Charity Day',
        slug:'Start-a-fundraiser-for-yourself-in-World-Charity-Days',
        screens: blogImg4,
        authorImg: author1,
        description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look',
        author: 'Kathryn Murphy',
        authorTitle:'Sineor Consultant',
        create_at: '12.January.2024',
        comment:'356',
        thumb:'Charity',
        blClass:'format-standard-image',
        col:'col-md-12 col-12',
        styleClass:'blogBlock--style1',
    },
    {
        id: '5',
        title: 'do you know why african people year of year waterless?',
        slug:'do-you-know-why-african-people-year-of-year-wateress',
        screens: blogImg5,
        authorImg: author2,
        description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look',
        author: 'Savannah Nguyen',
        authorTitle:'Creative Director',
        create_at: '22.January.2024',
        comment:'450',
        thumb:'Health',
        blClass:'format-standard-image',
        col:'col-md-6 col-12',
        styleClass:'blogBlock--style2',
    },
    {
        id: '6',
        title: 'Why you should join as a volunteer with us - 2024',
        slug: 'Why-you-should-join-as-a-volunteer-with-uss-2024',
        screens: blogImg6,
        authorImg: author3,
        description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look',
        author: 'Brooklyn Simmons',
        authorTitle:'Art Director',
        create_at: '25.January.2024',
        comment:'905',
        thumb:'Education',
        blClass:'format-video',
        col:'col-md-6 col-12',
        styleClass:'blogBlock--style2',
    }
];
export default blogs;
